import AdminSectionTitle from '../components/AdminSectionTitle';
import useGetSelectedEvent from '../hooks/useGetSelectedEvent';
import {
  useGetAudienceDiscountsQuery,
} from '../store';
import AudienceDiscountsTable from '../components/AudienceDiscountsTable';

const DiscountPage: React.FC = () => {
  const { event } = useGetSelectedEvent();
  const { data: AudienceDiscounts } = useGetAudienceDiscountsQuery({
    businessId: event?.business_id || '',
    eventId: event?.id || '',
  }, { skip: !event?.business_id || !event?.id });

  return (
    <div className='my-6 flex flex-col gap-8'>
      <AdminSectionTitle title="Eventos" subtitle={`${event?.name} - Descuentos`} />
      <AudienceDiscountsTable data={AudienceDiscounts?.data || []} />
    </div>
  );
};

export default DiscountPage;
